import { TipoCampoSql } from '../classes/esriClasses';
import { TipoCampo } from './enums';

function getFieldTypesForSqlWithQuotesRequired(){
    return [TipoCampo.string];
}
export function getFieldTypesForSql(){
    const camposComillas = getFieldTypesForSqlWithQuotesRequired();
    return [
        new TipoCampoSql(TipoCampo.smallInteger, camposComillas.includes(TipoCampo.smallInteger)),
        new TipoCampoSql(TipoCampo.integer, camposComillas.includes(TipoCampo.integer)),
        new TipoCampoSql(TipoCampo.single, camposComillas.includes(TipoCampo.single)),
        new TipoCampoSql(TipoCampo.double, camposComillas.includes(TipoCampo.double)),
        new TipoCampoSql(TipoCampo.long, camposComillas.includes(TipoCampo.long)),
        new TipoCampoSql(TipoCampo.string, camposComillas.includes(TipoCampo.string))
    ];
}

export function getFieldValueWithDomain(layer, campo, valor, retornarMismoValorSiNoTieneDominio = false){
    //Si campo no es coded-value y retornarMismoValorSiNoTieneDominio == false retorna false
    const domainCampo = layer.getFieldDomain(campo);
    if (domainCampo && domainCampo.type === "coded-value") {
        return domainCampo.codedValues.find(x => x.code === valor).name
    } else {
        return retornarMismoValorSiNoTieneDominio ? valor : false;
    }
}